<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.title">
          <el-input v-model="searchForm.query.title" placeholder="活动名称"></el-input>
        </el-form-item>
        <el-form-item prop="query.status">
          <status-option v-model="searchForm.query.status"></status-option>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item class="fr">
          <router-link :to="{ name: 'interaction-share-add' }">
            <el-button type="primary">新增分享有礼</el-button>
          </router-link>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <el-table :data="tableData">
        <el-table-column label="活动名称" prop="title"></el-table-column>
        <el-table-column label="活动时间" width="350" align="center">
          <template slot-scope="{ row }">{{ row.startTime }}~{{ row.endTime }}</template>
        </el-table-column>
        <el-table-column label="活动状态" width="150" align="center">
          <template slot-scope="{ row }">
            <badge :badge_type="STATUS_BADGE(row.status)">{{ STATUS_DESC(row.status) }}</badge>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="{ row }">
            <el-link @click="onCopy(`subPackages/interaction/share-activity?id=${row.id}`)" type="primary">链接</el-link>
            <router-link :to="{ name: 'interaction-share-add', query: { id: row.id } }">
              <el-link v-if="row.status !== ENDED" type="primary">编辑</el-link>
            </router-link>
            <router-link :to="{ name: 'interaction-activity-data', query: { id: row.id, type: 'share' } }">
              <el-link v-if="row.status !== UN_START" type="primary">数据</el-link>
            </router-link>
            <el-link v-if="row.status === UN_START" @click="handleDel(row)" type="danger">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination" />
    </el-card>
  </div>
</template>

<script>
import { delShareActivity, getShareList } from '@/api/interaction'
import { ENDED, NORMAL, STATUS_DESC, UN_START } from '@/enums/gift'
import { STATUS_BADGE } from '@/enums/gift'
import statusOption from '@/views/Interaction/components/status-option'

export default {
  name: 'share-activity',
  components: {
    statusOption
  },
  computed: {},
  data() {
    return {
      searchForm: {
        query: {
          title: undefined,
          status: undefined
        },
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },
      tableData: [],
      total: 0,

      STATUS_DESC,
      STATUS_BADGE,
      NORMAL,
      UN_START,
      ENDED
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    async handleDel(row) {
      await this.$confirm('确定删除此活动吗？')
      await delShareActivity(row.id)
      await this.init()
      this.$message.success('操作成功')
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    async init() {
      const { collection, meta } = await getShareList(this.searchForm)
      this.tableData = collection
      this.total = meta.total
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped></style>
